<template>
  <div>
    <Nav></Nav>
    <b-container>

      <b-card class="mt-3">
        <b-row class="px-3" align-v="center">
          <b-col class="ml--2">
            <h1 class="mb-0">
              Sucursal: {{ this.actualSucursal.nombre }}
            </h1>
            <div v-if="this.actualSucursal.status">
              <span class="text-success">● </span>
              <small>Activa</small>
            </div>
            <div v-else>
              <span class="text-danger">● </span>
              <small>Inactiva</small>
            </div>

          </b-col>
          <b-col md="auto">
            <base-button class="mx-3" @click="getSucursal" type="primary"
              size="sm"><b-icon-arrow-clockwise></b-icon-arrow-clockwise></base-button>
          </b-col>
        </b-row>
        <hr class="my-1" />
        <b-row>
          <b-col>
            <base-button type="primary" class="my-1" size="sm">Editar</base-button>
            <base-button  class="my-1" :disabled="!this.actualSucursal.status" @click="sendRemoteAction('updatePosVersion')" type="primary" size="sm">Actualizar version POS</base-button>
            <base-button  class="my-1" :disabled="!this.actualSucursal.status" @click="sendRemoteAction('updateInfo')" type="primary" size="sm">Actualizar Info POS</base-button>
          </b-col>
        </b-row>
        <hr class="my-1" />
        <b-row>
          <b-col>
            <h3 style="text-align: center;"></h3>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6" cols="12">
            <p>
              Version: {{ this.actualSucursal.version }}<br>
              Version de Base de datos: {{ this.actualSucursal.database_version }}<br>
              Estatus de migracion de base de datos: {{ (this.actualSucursal.database_dirty == 0 ? 'SALUDABLE' : 'NO SALUDABLE')
              }}<br>
              Ultima actualización: {{ this.actualSucursal.version_last_update }}
            </p>
          </b-col>
          <b-col md="6" cols="12">
            <p>
              ID Rappi: {{ this.actualSucursal.rappi_id }} <br>
              Menu Rappi: {{ this.actualSucursal.rappi_menu_id }}<br>
              ID Uber: {{ this.actualSucursal.uber_store_id }}<br>
              Menu Uber: {{ this.actualSucursal.uber_menu_id }}
            </p>
          </b-col>
        </b-row>
      </b-card>


      <b-card class="mt-3">
        <b-row class="px-3" align-v="center">
          <b-col class="ml--2">
            <h1 class="mb-0">Equipo POS (Servidor Local)</h1>
            <div v-if="device.active_device">
              <span class="text-success">● </span>
              <small>Registrado · {{ device.active_device.hostname || device.active_device.device_id }}</small>
            </div>
            <div v-else-if="device.needs_initial_device_claim">
              <span class="text-warning">● </span>
              <small>Sin registrar · ventana de migración legacy abierta</small>
            </div>
            <div v-else>
              <span class="text-warning">● </span>
              <small>Sin registrar · el técnico debe usar el código de provisión</small>
            </div>
          </b-col>
          <b-col md="auto">
            <base-button class="mx-3" @click="getDevice" type="primary" size="sm">
              <b-icon-arrow-clockwise></b-icon-arrow-clockwise>
            </base-button>
          </b-col>
        </b-row>
        <hr class="my-1" />
        <b-row>
          <b-col md="6">
            <h4>Código de provisión</h4>
            <p>
              <code style="font-size: 1.2rem; padding: 4px 8px; background: #f5f5f5; border-radius: 4px">
                {{ device.provisioning_code || '—' }}
              </code>
              <base-button v-if="device.provisioning_code" class="ml-2" size="sm" type="secondary"
                @click="copyCode">
                <b-icon-clipboard></b-icon-clipboard> Copiar
              </base-button>
            </p>
            <p class="text-muted small">
              Compártelo solo con el técnico que instalará el POS en esta sucursal.
            </p>
            <base-button type="warning" size="sm" @click="confirmRotateCode" :disabled="rotating">
              Rotar código
            </base-button>
          </b-col>
          <b-col md="6" v-if="device.active_device">
            <h4>Dispositivo activo</h4>
            <p>
              <strong>device_id:</strong> <code>{{ device.active_device.device_id }}</code><br>
              <strong>hostname:</strong> {{ device.active_device.hostname || '—' }}<br>
              <strong>registrado:</strong> {{ device.active_device.registered_at }}<br>
              <strong>última actividad:</strong> {{ device.active_device.last_seen_at || '—' }}<br>
              <strong>origen del registro:</strong>
              <b-badge :variant="device.active_device.claim_source === 'legacy_existing' ? 'secondary' : 'primary'">
                {{ device.active_device.claim_source }}
              </b-badge>
            </p>
            <base-button type="danger" size="sm" @click="confirmRelease" :disabled="releasing">
              Liberar dispositivo
            </base-button>
          </b-col>
        </b-row>
      </b-card>

      <b-card class="mt-3" >
        <b-row class="px-3" align-v="center">
          <b-col class="ml--2">
            <h1 class="mb-0">
              Uber Eats
            </h1>
            <div v-if="this.actualSucursal.uber_store_id==null">
              <span class="text-warning">● </span>
              <small>No Configurado</small>
            </div>
            <div v-else-if="this.eatsStatus.status == 'ONLINE'">
              <span class="text-success">● </span>
              <small>Activa</small>
            </div>
            <div v-else-if="this.eatsStatus.status == 'OFFLINE'">
              <span class="text-danger">● </span>
              <small>INACTIVA Razon: {{ this.eatsStatus.offlineReason}} {{ this.eatsStatus.paused_until}}</small>
            </div>
            <div v-else-if="this.eatsStatus.status == ''">
              <span class="text-warning">● </span>
              <small>Sin Informacion</small>
            </div>
           
          </b-col>
          <b-col md="auto">
            <base-button v-if="this.actualSucursal.uber_store_id!=null" class="mx-3" @click="getUberInfo" type="primary"
              size="sm"><b-icon-arrow-clockwise></b-icon-arrow-clockwise></base-button>
          </b-col>
        </b-row>
        <hr class="my-1" />
        <div v-if="this.actualSucursal.uber_store_id!=null">
          <b-row v-if="this.hasPermission('rrn:central:platforms:uber')">
            <b-col>
              <base-button  class="my-1"  @click="sendUberMenu" type="primary" size="sm">Enviar Menu Uber</base-button>
            </b-col>
          </b-row>
          <hr class="my-1" />

          <b-row >
            <b-col>
              <b-alert :show="!this.uberInfo.pos_data.integration_enabled" variant="warning">La integración no se encuentra activa para esta tienda. Solicita a tu contacto de soporte que active esta tienda.</b-alert>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12" cols="12">
              <p>
                Nombre: {{ this.uberInfo.name }}<br>
                ID de Tienda: {{ this.uberInfo.store_id }}<br>
                Direccion: {{ this.uberInfo.location.address }}<br>
                Tiempo Promedio Prep: {{ this.uberInfo.avg_prep_time }}<br>
                Status: {{ this.uberInfo.status }}<br>
                Status Integración: {{ this.uberInfo.pos_data.integration_enabled }}<br>
                Url web: <a :href="uberInfo.web_url">{{ this.uberInfo.web_url }}</a>
                
              </p>
              <h4>De la integracion</h4>
              <p>
                Auto Aceptacion: <b-icon v-if="this.uberIntegrationInfo.auto_accept_enabled" icon="check-square" variant="success"></b-icon> <b-icon v-else icon="x-circle" variant="danger"></b-icon><br>
                Requiere Aceptacion Manual: <b-icon v-if="this.uberIntegrationInfo.require_manual_acceptance" icon="check-square" variant="success"></b-icon> <b-icon v-else icon="x-circle" variant="danger"></b-icon><br>
                Integración habilitada: <b-icon v-if="this.uberIntegrationInfo.integration_enabled" icon="check-square" variant="success"></b-icon> <b-icon v-else icon="x-circle" variant="danger"></b-icon><br>
                Status: {{ this.uberIntegrationInfo.online_status }}<br>
                Order Release Enabled: <b-icon v-if="this.uberIntegrationInfo.order_release_enabled" icon="check-square" variant="success"></b-icon> <b-icon v-else icon="x-circle" variant="danger"></b-icon><br>
                Pos integration enabled: <b-icon v-if="this.uberIntegrationInfo.pos_integration_enabled" icon="check-square" variant="success"></b-icon> <b-icon v-else icon="x-circle" variant="danger"></b-icon><br>
              </p>
            </b-col>
          </b-row>
        </div>
        
      </b-card>

      <b-card class="mt-3" >
        <b-row class="px-3" align-v="center">
          <b-col class="ml--2">
            <h1 class="mb-0">
              Configuraciones
            </h1>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <p>
              companyName: {{ cfgs.companyName.param1 }}<br>
              razonSocial: {{ cfgs.razonSocial.param1 }}<br>
              regimenFiscal: {{ cfgs.regimenFiscal.param1 }}<br>
              rfc: {{ cfgs.rfc.param1 }}<br>
              direccionMatriz1: {{ cfgs.direccionMatriz1.param1 }}<br>
              direccionMatriz2: {{ cfgs.direccionMatriz2.param1 }}<br>
              direccionMatriz3: {{ cfgs.direccionMatriz3.param1 }}<br>
              sucursalName: {{ cfgs.sucursalName.param1 }}<br>
              direccionSucursal1: {{ cfgs.direccionSucursal1.param1 }}<br>
              direccionSucursal2: {{ cfgs.direccionSucursal2.param1 }}<br>
              direccionSucursal3: {{ cfgs.direccionSucursal3.param1 }}<br>
              maxCashPaydesk: {{ cfgs.maxCashPaydesk.param1 }}<br>
              ticketLastLine: {{ cfgs.ticketLastLine.param1 }}<br>
            </p>
          </b-col>
        </b-row>
      </b-card>
    </b-container>
  </div>
</template>
<script>
import Nav from "../components/Nav.vue";
import axios from "axios";
import _ from 'lodash';

export default {
  name: "Sucursal",
  components: { Nav },
  data() {
    return {
      configs:[],
      cfgs:{
        companyName:{param1:"",param2:"",param3:"",param4:""},
        direccionMatriz1:{param1:"",param2:"",param3:"",param4:""},
        direccionMatriz2:{param1:"",param2:"",param3:"",param4:""},
        direccionMatriz3:{param1:"",param2:"",param3:"",param4:""},
        direccionSucursal1:{param1:"",param2:"",param3:"",param4:""},
        direccionSucursal2:{param1:"",param2:"",param3:"",param4:""},
        direccionSucursal3:{param1:"",param2:"",param3:"",param4:""},
        maxCashPaydesk:{param1:"",param2:"",param3:"",param4:""},
        razonSocial:{param1:"",param2:"",param3:"",param4:""},
        rfc:{param1:"",param2:"",param3:"",param4:""},
        ticketLastLine:{param1:"",param2:"",param3:"",param4:""},
        sucursalName:{param1:"",param2:"",param3:"",param4:""},
        regimenFiscal:{param1:"",param2:"",param3:"",param4:""},

      },

      actualSucursal: {
        id: 0,
        description: "",
        code: "",
        name: "",
        unit: "",
        base_portion: 1
      },
      device: {
        sucursal_id: 0,
        provisioning_code: "",
        needs_initial_device_claim: false,
        active_device: null,
      },
      releasing: false,
      rotating: false,
      eatsStatus: {
        status: "",
        offlineReason: ""
      },

      uberIntegrationInfo:{
        store_id: "",
        pos_integration_enabled: false,
        online_status: "",
        partner_store_id: "",
        order_release_enabled: false,
        auto_accept_enabled: false,
        order_manager_client_id: "",
        integration_enabled: false
      },
      uberInfo: {
        name: "",
        store_id: "",
        location: {
          address: "",
          address_2: "",
          city: "",
          country: "",
          postal_code: "",
          state: "",
          latitude: 0,
          longitude: 0
        },
        contact_emails: [
        ],
        raw_hero_url: "",
        price_bucket: "",
        avg_prep_time: 0,
        status: "",
        partner_store_id: "",
        timezone: "",
        pos_data: {
          integration_enabled: false,
          order_manager_client_id: ""
        },
        merchant_store_id: "",
        web_url: ""
      }
    };
  },
  beforeRouteUpdate(to, from) {
    console.log(to);
    console.log(from);
    this.initData();
  },
  mounted() {
    this.initData();
  },
  methods: {
    initData() {
      console.log("creando");
      console.log(this.$route.params.id);
      if (this.$route.params.id > 0) {
        console.log("producto no nuevo");
        this.actualSucursal.id = this.$route.params.id;
        this.getSucursal();
      }
      console.log("termina creacion");
      this.getRestaurantConfigs()
    },
    getRestaurantConfigs(){
      let that=this
      axios.get("/restaurant/"+this.actualSucursal.id+"/config")
      .then(function(res){
        that.configs=res.data
        _.forOwn(that.cfgs, function(value, key) { 
          console.log(key+" "+value)
          let res=_.find(that.configs,function(n){
            return n.id==key
          })
          if(res!=undefined){
            that.cfgs[key].param1=res.param1
            that.cfgs[key].param2=res.param2
            that.cfgs[key].param3=res.param3
          }
          console.log(res)
          
        } );
      }).catch(function(e){
        console.error(e)
      })
    },
    getUberInfo() {
      let that = this;
      axios
        .get("/uber/store/" + this.actualSucursal.uber_store_id+"/status")
        .then(function (response) {
          that.eatsStatus = response.data;
        })
        .catch(function (err) {
          that.makeToast("Error", err.request.response, "danger");
        });
        axios
        .get("/uber/store/" + this.actualSucursal.uber_store_id+"/info")
        .then(function (response) {
          that.uberInfo = response.data;
        })
        .catch(function (err) {
          that.makeToast("Error", err.request.response, "danger");
        });
        axios
        .get("/uber/store/" + this.actualSucursal.uber_store_id+"/integration/status")
        .then(function (response) {
          console.log("getuberposinfo")
          console.log(response.data)
          that.uberIntegrationInfo = response.data;
        })
        .catch(function (err) {
          that.makeToast("Error", err.request.response, "danger");
        });
    },

    getSucursal() {
      let that = this;
      axios
        .get("/sucursal/" + this.actualSucursal.id)
        .then(function (response) {
          that.actualSucursal = response.data;
          if (that.actualSucursal.uber_store_id!=null){
            that.getUberInfo()
          }
          that.getDevice();
        })
        .catch(function (err) {
          that.makeToast("Error", err.request.response, "danger");
        });
    },
    getDevice() {
      let that = this;
      axios
        .get("/sucursal/" + this.actualSucursal.id + "/device")
        .then(function (response) {
          that.device = response.data;
        })
        .catch(function (err) {
          // 404 just means no row exists yet; not an error worth toasting.
          if (err.response && err.response.status !== 404) {
            that.makeToast("Error", err.request.response, "danger");
          }
        });
    },
    copyCode() {
      if (!this.device.provisioning_code) return;
      navigator.clipboard.writeText(this.device.provisioning_code).then(
        () => this.makeToast("Copiado", "Código copiado al portapapeles", "success"),
        () => this.makeToast("Error", "No se pudo copiar al portapapeles", "danger"),
      );
    },
    confirmRotateCode() {
      this.$bvModal
        .msgBoxConfirm(
          "Esto generará un código nuevo. El dispositivo registrado actualmente NO se desconecta (sigue funcionando con su device_secret). El código anterior dejará de ser válido para futuras claims. ¿Continuar?",
          {
            title: "Rotar código de provisión",
            okVariant: "warning",
            okTitle: "Rotar código",
            cancelTitle: "Cancelar",
            centered: true,
          }
        )
        .then((ok) => {
          if (ok) this.rotateCode();
        });
    },
    rotateCode() {
      this.rotating = true;
      let that = this;
      axios
        .post("/sucursal/" + this.actualSucursal.id + "/device/rotate-code")
        .then(function (response) {
          that.device.provisioning_code = response.data.provisioning_code;
          that.makeToast("Código rotado", "Nuevo código: " + response.data.provisioning_code, "success");
        })
        .catch(function (err) {
          that.makeToast("Error", err.request.response, "danger");
        })
        .finally(() => {
          that.rotating = false;
        });
    },
    confirmRelease() {
      this.$bvModal
        .msgBoxConfirm(
          "Esto desconectará al equipo POS de esta sucursal. Las sesiones activas se invalidan inmediatamente. El siguiente equipo que se instale deberá usar el código de provisión (la ventana legacy NO se reabre). ¿Continuar?",
          {
            title: "Liberar dispositivo",
            okVariant: "danger",
            okTitle: "Liberar",
            cancelTitle: "Cancelar",
            centered: true,
          }
        )
        .then((ok) => {
          if (ok) this.releaseDevice();
        });
    },
    releaseDevice() {
      this.releasing = true;
      let that = this;
      axios
        .delete("/sucursal/" + this.actualSucursal.id + "/device")
        .then(function () {
          that.makeToast("Liberado", "El dispositivo fue liberado", "success");
          that.getDevice();
        })
        .catch(function (err) {
          that.makeToast("Error", err.request.response, "danger");
        })
        .finally(() => {
          that.releasing = false;
        });
    },
    updateProduct() {
      let that = this;
      if (this.actualSucursal.id > 0) {
        axios
          .put("/supply/" + this.actualSucursal.id, this.actualSucursal)
          .then(function (response) {
            that.actualSucursal = response.data;
            that.makeToast("Exito", "exito al guardar", "success");
            that.getSucursal();
          })
          .catch(function (err) {
            that.makeToast("Error", err.request.response, "danger");
          });
      } else {
        axios
          .post("/supply", this.actualSucursal)
          .then(function (response) {
            that.makeToast("Exito", "exito al crear, redirigiendo", "success");
            console.log(response.data);
            that.$router.push({
              name: "Sucursal",
              params: { id: response.data.id },
            });
          })
          .catch(function (err) {
            that.makeToast("Error", err.request.response, "danger");
          });
      }
    },
    sendUberMenu() {
      let that = this
      axios
        .put("/sucursal/" + this.actualSucursal.id + "/uber/uploadmenu", null)
        .then(function () {
          that.makeToast("Exito", "EXITO AL SUBIR EL MENU", "success");
        })
        .catch(function (err) {
          that.makeToast("Error", err.request.response, "danger");
        });

    },

    sendRemoteAction(actiontype) {
      let that = this
      axios
        .get("/sucursal/" + this.actualSucursal.id + "/action/" + actiontype)
        .then(function () {
          that.makeToast("Exito", "EXITO AL enviar la accion", "success");
        })
        .catch(function (err) {
          that.makeToast("Error", err.request.response, "danger");
        });
 
    },
    makeToast(title, content, variant) {
      this.$bvToast.toast(content, {
        title,
        variant,
        autoHideDelay: 5000,
        appendToast: true,
      });
    },
  },
};
</script>
